/**
 * Rôles applicatifs.
 *
 * Un utilisateur porte 1..n rôles. Les droits effectifs sont la réunion des droits
 * de chacun de ses rôles (voir `security/rightsMatrix.ts`) + ses droits additionnels.
 */
export enum Role {
	/** Client final (rider). Rôle par défaut à l'inscription. */
	CLIENT = 'ROLE_CLIENT',
	/** Chauffeur de taxi monégasque. Écran d'accueil = mode conduite. */
	DRIVER = 'ROLE_DRIVER',
	/** Agent du back-office (supervision courses / chauffeurs). */
	OPERATOR = 'ROLE_OPERATOR',
	/** Administrateur : tout le BO + gestion des utilisateurs et des droits. */
	ADMIN = 'ROLE_ADMIN',
	/** Compte machine d'une borne (kiosk). Ne peut pas se comporter comme un humain. */
	KIOSK = 'ROLE_KIOSK',
	/** Session anonyme créée pour une commande sans compte (borne ou web). */
	GUEST = 'ROLE_GUEST',
}

export const ALL_ROLES: Role[] = Object.values(Role);

/** Rôles qu'un administrateur peut attribuer depuis le back-office. */
export const ASSIGNABLE_ROLES: Role[] = [
	Role.CLIENT,
	Role.DRIVER,
	Role.OPERATOR,
	Role.ADMIN,
];
